import _ from "lodash";

export * from "./getHeaders";
export * from "./getColumns";
export * from "./getColumnSort";

/**
 * A function to reorder the columns when they've been dragged to a new index
 *
 * @param columnOrder the list of columns indexes in order
 * @param startIndex the index where the column started
 * @param endIndex the index where the column ended
 * @returns the new column order
 */
export const reorder = (columnOrder: number[], startIndex: number, endIndex: number): number[] => {
  const tempColumnOrder = _.cloneDeep(columnOrder);
  const [removed] = tempColumnOrder.splice(startIndex, 1);
  tempColumnOrder.splice(endIndex, 0, removed);
  return tempColumnOrder;
};
